export default __webpack_public_path__ + "static/media/flat-tire.6e35fce6.webp";